import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const apiClient = axios.create({
  withCredentials: true,
});

const bareApi = axios.create({
  withCredentials: true,
});

async function refreshAuthToken() {
  const csrfToken = getCookie('csrf_refresh_token');
  if (!csrfToken) {
    console.error("CSRF Refresh Token não encontrado. Abortando refresh.");
    return Promise.reject(new Error("CSRF Refresh Token não encontrado"));
  }

  return bareApi.post('/api/refresh', {}, {
    headers: {
      'X-CSRF-TOKEN': csrfToken,
    }
  });
}

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }
  return null;
}

apiClient.interceptors.request.use(
  config => {
    const csrfMethods = ['post', 'put', 'patch', 'delete'];
    console.log(document.cookie)
    if (config.method && csrfMethods.includes(config.method.toLowerCase())) {
      let csrfToken;
      if (config.url.endsWith('/api/refresh')) {
        csrfToken = getCookie('csrf_refresh_token');
      } else {
        csrfToken = getCookie('csrf_access_token');
      }

      if (csrfToken) {
        config.headers['X-CSRF-TOKEN'] = csrfToken;
      } else {
        console.warn(`Cookie CSRF não encontrado para ${config.url}`);
      }
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

apiClient.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && 
        !originalRequest._retry && 
        error.response.data?.msg === "Token expirou.") { // Mensagem do seu backend
      
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        }).then(token => {
          originalRequest.headers['Authorization'] = 'Bearer ' + token; // Se você mudar para header auth
          return apiClient(originalRequest);
        }).catch(err => {
          return Promise.reject(err);
        });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        console.log("Tentando refresh do token...");
        await refreshAuthToken();
        console.log("Refresh do token bem-sucedido.");
        
        processQueue(null, null);
        isRefreshing = false;

        return apiClient(originalRequest);
      } catch (refreshError) {
        console.log("Deu erro");
        console.error("Falha ao dar refresh no token:", refreshError);
        processQueue(refreshError, null);
        isRefreshing = false;
        console.log("Disparando evento de logout global.");
        window.dispatchEvent(new Event('auth-error-logout'));
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);


export default apiClient;